import styled from 'styled-components';
import { TEXT_PRIMARY } from '../../HostfullyAssist.styles';

export const AssistPropertiesSelectTableContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;

  .checkbox {
    margin: 0;
  }

  .checkbox input[type='checkbox'] {
    margin: 0;
    position: static;
  }

  .checkbox label {
    min-height: 0;
    padding-left: 0;
  }

  label {
    cursor: pointer;
    font-weight: 400;
    margin: 0;
  }

  caption {
    caption-side: top;
    color: ${TEXT_PRIMARY};
    font-size: 1.25rem;
    font-weight: 400;
    padding: 0 0 8px;
    text-align: left;
  }

  thead th {
    background-color: #fff;
    border-bottom-width: 1px;
    font-weight: 400;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .table {
    td,
    th {
      border: none;
      vertical-align: middle;
    }

    td:first-child,
    th:first-child {
      padding-right: 0;
      width: 1px;
    }
  }
`;
